import { supabase } from "@/supabase";
import { useFeedbackStore } from "@/store/useFeedbackStore";

export async function carregarModelosQuestoes(){
    const { data, error } = await supabase
    .from('questoes_modelos')
    .select()
    .eq("mostrar", true)
     .order('titulo', { ascending: true })

    return { data, error };
}

export async function carregarNiveisComplexidade(){
    const { data, error } = await supabase
    .from('questoes_niveis_complexidade')
    .select()
    if(error){
        console.log(error.message);
        return;
    }

    return data;
}

export async function salvarQuestao(questao) {
    const store = useFeedbackStore();
    const { data, error } = await supabase
        .from('questoes')
        .insert([questao])
        .select()

    store.show(error, "A questão foi adicionada com sucesso");

    return { data, error };
}

export async function salvarAnalitycsQuestao(idQuestao, modelo, versao){
    console.log(idQuestao, modelo, versao)


    const { data, error } = await supabase
        .from('questoes_analitycs')
        .insert([
            { questao: idQuestao, modelo: modelo, versao_modelo: versao },
        ])
        .select()



        if(error){ 
            console.log(error.message);
            return;
        }

        console.log(data)
}

export async function salvarQuestoesConsumoApi(numero_questoes_geradas, tokens, modelo) {

    const { data, error } = await supabase
        .from('questoes_consumo_api')
        .insert([
            { numero_questoes_geradas: numero_questoes_geradas, tokens: tokens, modelo: modelo },
        ])
        .select()
        if(error){ 
            console.log(error.message);
            return;
        }

}

export async function carregarQuestoes(disciplina, proprietario, nivel_complexidade, tipo, texto, conceitos, numeroDaPagina) {

    if(numeroDaPagina === undefined || numeroDaPagina === null){
        numeroDaPagina = 1 * 10
    }else{
        numeroDaPagina = numeroDaPagina * 10
    }

    let query = supabase.from('questoes').select('*').range(numeroDaPagina - 10, numeroDaPagina - 1);

    if (disciplina !== null && disciplina !== undefined) {
        query = query.eq('disciplina', disciplina);
    }


    if (nivel_complexidade !== null && nivel_complexidade !== undefined) {
        query = query.eq('nivel_complexidade', nivel_complexidade);
    }

    if (tipo !== null && tipo !== undefined) {
        query = query.eq('tipo', tipo);
    }

    if (proprietario !== null && proprietario !== undefined) {
        console.log('entrou aqui')
        query = query.eq('proprietario', proprietario);
    }

    if (texto !== null && texto !== undefined && texto !== '') {
        const colunas = ['conceitos', 'texto', 'pergunta', 'a', 'b', 'c', 'd', 'e'];
        const ilikeQueries = colunas.map(coluna => `${coluna}.ilike.%${texto}%`).join(',');
        query = query.or(ilikeQueries);
    }

    if (conceitos && conceitos.length > 0) {
        const ilikeQueries = conceitos.map(conceito => `conceitos.ilike.%${conceito}%`).join(',');
        query = query.or(ilikeQueries);
    }

    query = query.order('id', { ascending: false });

    const { data, error } = await query;

    if (error) {
        console.error(error.message);
        return null;
    }

    console.log(data)

    return data;
}



export async function atualizarQuestao(id, atualizacoes) {
    const { data, error } = await supabase
        .from('questoes')
        .update(atualizacoes)
        .eq('id', id);

    if (error) {
        console.error('Erro ao atualizar questão:', error);
        return null;
    } else {
        return data;
    }
}

export async function deletarQuestao(id) {
    const { data, error } = await supabase
        .from('questoes')
        .delete()
        .eq('id', id);

    if (error) {
        console.error('Erro ao deletar questão:', error);
        return null;
    } else {
        return data;
    }
}

export async function carregarConceitos(){

    const { data, error } = await supabase
    .from('questoes')
    .select('conceitos')

    return { data, error };
}
